module.exports = __webpack_public_path__ + "static/media/n-it_3.518b854a.png";